import React from "react";
import { useTranslation } from "react-i18next";

import Card from "../Card";
import styles from "./PrizesInfoCard.module.css";

const PrizesInfoCard = ({ onButtonClick }) => {
	const { t } = useTranslation();

	return (
		<Card title={t("common.prizesInfoCard.title")}>
			<p className={styles.prizeDescription} style={{ marginBottom: "10px" }}>
				{t("common.prizesInfoCard.description1")}
			</p>
			<p className={styles.prizeDescription}>{t("common.prizesInfoCard.description2")}</p>
			<div className={styles.buttonWrapper}>
				<button className={styles.inviteButton} onClick={onButtonClick}>
					{t("common.prizesInfoCard.button")}
				</button>
			</div>
		</Card>
	);
};

export default PrizesInfoCard;
